import type { z } from 'zod';

import { objectKeys } from './objectKeys';

export const buildSchemaShape = <T extends Record<string, unknown>>({
    getSchema,
    obj,
}: {
    getSchema: (key: keyof T) => z.ZodTypeAny;
    obj: T;
}): { [K in keyof T]: z.ZodTypeAny } =>
    Object.fromEntries(objectKeys(obj).map((k) => [k, getSchema(k)])) as { [K in keyof T]: z.ZodTypeAny };
